import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import '../../App.css';
import './OrderReceived.css';
import { functions } from '../../firebase';
import { httpsCallable } from 'firebase/functions';

function OrderReceived() {
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get('orderId');
    const [state, setState] = useState('idle'); // idle | cancelling | cancelled | error
    const [msg, setMsg] = useState('');

    useEffect(() => {
        document.title = 'Order Received | OFFF THE ROAST';
    }, []);

    const handleCancel = async () => {
        if (!window.confirm('Cancel your order? If you paid online, your card will be refunded in full.')) {
            return;
        }
        setState('cancelling');
        setMsg('');
        try {
            const fn = httpsCallable(functions, 'cancelMyOrder');
            const res = await fn({ orderId });
            const d = res.data || {};
            setState('cancelled');
            if (d.refunded) {
                setMsg('Your order was cancelled and your card has been refunded in full.');
            } else if (d.alreadyCancelled) {
                setMsg('This order was already cancelled.');
            } else {
                setMsg('Your order was cancelled.');
            }
        } catch (err) {
            setState('error');
            setMsg(err.message || 'We could not cancel your order. Please talk to staff at the sign.');
        }
    };

    return (
        <div className='orderok'>
            <div className='orderok__card'>
                {state === 'cancelled' ? (
                    <>
                        <div className='orderok__mark orderok__mark--cancel'>✕</div>
                        <h1 className='orderok__title'>Order cancelled</h1>
                        <p className='orderok__msg'>{msg}</p>
                        <Link to='/menu' className='orderok__btn'>BACK TO MENU</Link>
                    </>
                ) : (
                    <>
                        <div className='orderok__mark'>✓</div>
                        <h1 className='orderok__title'>Your order is received</h1>
                        <p className='orderok__msg'>
                            We&rsquo;re preparing your drinks right now.
                            <br />
                            Please wait near the walk sign — we&rsquo;ll have them ready for you shortly.
                        </p>

                        {orderId && (
                            <div className='orderok__cancel-box'>
                                <p className='orderok__cancel-hint'>
                                    Changed your mind? You can cancel now, before we start making it.
                                </p>
                                {state === 'error' && <p className='orderok__error'>{msg}</p>}
                                <button
                                    className='orderok__cancel-btn'
                                    onClick={handleCancel}
                                    disabled={state === 'cancelling'}
                                >
                                    {state === 'cancelling' ? 'CANCELLING…' : 'CANCEL MY ORDER'}
                                </button>
                            </div>
                        )}

                        <Link to='/menu' className='orderok__btn'>BACK TO MENU</Link>
                    </>
                )}
            </div>
        </div>
    );
}

export default OrderReceived;
